import type { CloudAuthFailureState } from "../rpc/wsConnectionState";
import type { RuntimeSurfaceState } from "../environments/runtimeSurface";

/**
 * Decides whether the cloud session recovery surface should be shown.
 * True only when:
 * 1. The cloud auth failure state is "expired"
 * 2. The runtime surface is "desktop-cloud" (desktop app in cloud mode)
 *
 * Browser/cookie sessions and desktop-local mode are never affected.
 */
export function shouldShowCloudAuthRecovery(
  failureState: CloudAuthFailureState,
  runtimeSurface: RuntimeSurfaceState,
): boolean {
  if (failureState.status !== "expired") return false;
  return runtimeSurface.surface === "desktop-cloud";
}
